import {Button} from '_core'
import {useCallback, useRef} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useParams} from 'react-router-dom'
import {RootState} from 'setup'
import clsx from 'clsx'
import {
  checkCompliance,
  selectEditOrder,
  selectIsTaxRemoved,
  setIsTaxRemoved,
  updateEditOrderTaxAndAutoDiscountRemoved,
} from '../../redux/order/orderEditSlice'
import {Order} from '../../models/EditOrderState'

interface Props {
  onComplianceCheck: any
}

const EnableTaxCalculation: React.FC<Props> = () => {
  const {id} = useParams<any>()
  const dispatch = useDispatch()
  const isTaxRemoved = useSelector<RootState, boolean>(selectIsTaxRemoved)
  const timeoutRef = useRef<any | null>(null)
  const order = useSelector<RootState, Order>(selectEditOrder)

  const handleCheckShippingCompliance = useCallback(
    async (isTaxRemoved: boolean) => {
      try {
        await updateEditOrderTaxAndAutoDiscountRemoved({isTaxRemoved, id: order.orderEditId})
        dispatch(checkCompliance())
      } catch (error) {
        console.log(error)
      }
    },
    [dispatch, order, id]
  )

  const handleToggleTax = () => {
    const value = !isTaxRemoved
    dispatch(setIsTaxRemoved(value))
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    const timeoutId = setTimeout(() => handleCheckShippingCompliance(value), 1000)
    timeoutRef.current = timeoutId
  }

  // if (!id) {
  //   return null
  // }

  return (
    <Button
      id='btnTaxCalculation'
      className={clsx(
        'btn btn-link p-0 bg-transparent text-primary-active fw-bolder',
        isTaxRemoved ? 'me-2' : 'me-0'
      )}
      title={isTaxRemoved ? 'Enable' : 'Disable'}
      onClick={handleToggleTax}
    />
  )
}

export default EnableTaxCalculation
